"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _constants = require("../../constants");
var Icon = function Icon(props) {
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, props, {
    onClick: props.toggle
  }));
};
Icon.propTypes = {
  buttonType: _propTypes["default"].string,
  shrinkMobile: _propTypes["default"].bool,
  getLabel: _propTypes["default"].func,
  toggle: _propTypes["default"].func,
  context: _propTypes["default"].object
};
Icon.defaultProps = {
  buttonType: _constants.BUTTON_TYPES.WHITE,
  shrinkMobile: false
};
var _default = exports["default"] = Icon;